import { gql } from '@apollo/client';

export const getSitesEvseCount = gql`
  query GetSitesEvseCount {
    getSitesForExtend {
      evseCount
    }
  }
`;
